module.exports = __webpack_public_path__ + "static/media/ganesh.4041e6a0.jpg";